<div class="flex flex-column ml-5">
  <span class="text-xl font-bold">
    Bitte bestätigen Sie das Löschen des Signaturprozesses. Die Daten werden unwiderruflich gelöscht.
  </span>
    <p>&nbsp;</p>

    <div class="flex justify-content-center">
        <p-button
            [label]="'Löschen'"
            [outlined]="true"
            severity="danger"
            (click)="confirmDelete()">
        </p-button>
    </div>
</div>
